module.exports = __webpack_public_path__ + "static/media/grey-s-10.471cf6f8.png";